import * as React from 'react';
import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import {
    Afr, existFactsInTable, generateLocalStateFromEventProperties,
    getSelectedAfr, updateTableFact, updateVersionStateValue
} from '../../redux/AfrSlice';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { isAdmin, setIsDirty } from '../../redux/MiscSlice';
import { AccountEditorGridNoSubaccounts } from '../core/AccountEditorGridNoSubaccounts';
import Page from '../Page';




const DataElementWorksheetCore = (props: { userRole: string }) => {

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const ename = entity ? entity.name : "";
    const ecode = entity ? entity.code : "";
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, ["workState_balanceSheetComplete", "workState_noBalanceSheet", "reviewState_balanceSheetReviewed"]));
    const [hasFacts, setHasFacts] = useState(true);
    const isAdminUser: boolean = useAppSelector(isAdmin);

    const currVersion = function () {
        if (currentAfr) {
            if (currentAfr.currentversion) {
                if (currentAfr.currentversion.versionState) {
                    return currentAfr.currentversion.versionState;
                }
            }
        }
        return null;
    }

    // Cell Handler
    const dispatch = useAppDispatch();


    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var dimensionCode = row.getData().dimensionCode;
        var rowid = row.getData().accountCode + "|" + dimensionCode;
        var conceptId = row.getData().accountId;
        var newvalue = cell.getValue();
        dispatch(updateTableFact(
            {
                tableId: "uas_063_data-element-worksheet",
                rowId: rowid,
                fundGroup: "period",
                concept: conceptId,
                value: newvalue
            }));

    }

    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        checkValues[key] = value;

        setState(checkValues);

        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

    }


    useEffect(() => {
        if (!currentAfr) return;
        if (!currentAfr.currentversion) return;
        // get state from redux
        var newLocalState = generateLocalStateFromEventProperties(currentAfr, ["workState_balanceSheetComplete", "workState_noBalanceSheet", "reviewState_balanceSheetReviewed"])

        // enable/disable checkbox when there are (no) facts 
        setHasFacts(existFactsInTable(currentAfr, ["uas_063_data-element-worksheet"]))

        // create a local state from redux
        setState(newLocalState)

    }, [currentAfr, currVersion()])

    const editorOptions = {
        gridname: "dew",
        cellEditHandler: handleCellEdited,
        doneFlag: "workState_dewComplete",
        noFlag: "workState_noDew",
        fixedRows: true,
        dimensionColumn: {
            axis: "FundGroupsAxis",
            title: "Included Funds",
            codeLabelMap: {
                "001-399": "Governmental",
                "400-599": "Proprietary"
            }
        },
        firstFieldId: "FG_001_399_GovernmentalFundsMember",
        allowedCombinations: [
            "910001|FG_001_399_GovernmentalFundsMember",
            "910002|FG_001_399_GovernmentalFundsMember",
            "910003|FG_001_399_GovernmentalFundsMember",
            "910004|FG_400_599_ProprietaryFundsMember",
            "910005|FG_001_399_GovernmentalFundsMember",
            "910005|FG_400_599_ProprietaryFundsMember",
            "910006|FG_001_399_GovernmentalFundsMember",
            "910006|FG_400_599_ProprietaryFundsMember",
            "910007|FG_001_399_GovernmentalFundsMember",
            "920001|FG_001_399_GovernmentalFundsMember",
            "920002|FG_001_399_GovernmentalFundsMember",
            "920002|FG_400_599_ProprietaryFundsMember",
            "920003|FG_400_599_ProprietaryFundsMember",
            "930001|FG_001_399_GovernmentalFundsMember",
            "930002|FG_001_399_GovernmentalFundsMember",
            "930003|FG_400_599_ProprietaryFundsMember"
        ],
        accountRangeFilter: null,
        accountGroups: {
            "910001" : "Assigned and Unassigned Fund Balances",
            "910002": "Assigned and Unassigned Fund Balances"
        }
    };

    return (
        <React.Fragment>
            <Page>
                <Row>
                    <Col>
                        <div>
                            <AccountEditorGridNoSubaccounts
                                tableName="uas_063_data-element-worksheet"
                                gridData={[]}
                                gridColumns={[]}
                                gridOptions={{ layout: "fitColumns", groupBy: "accountGroup", columnCalcs: "group" }}
                                options={editorOptions}
                            />
                        </div>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default DataElementWorksheetCore;